var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-header',{staticClass:"pb-6",attrs:{"type":"gradient-success"}}),_c('show-product')],1)}
var staticRenderFns = []

export { render, staticRenderFns }